import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import { IConversionOffer, ISegmentOffer } from '../../utils/type';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const { requestCreateOffer } = useService();

	const createOffer = (conversionOffer: ISegmentOffer) => {
		setShowLoader(true);
		requestCreateOffer(app.appName, { ...conversionOffer }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the CTD Offer', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Offer Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
		return {};
	};

	const handleFormSubmit = (submittedData: IConversionOffer) => {
		createOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	const segmentList: { id: string; label: string[] } = history?.location?.state?.segmentList;
	const mapValues: {
		segmentExp: { [key: string]: { expName: string } };
		expBucket: {
			[key: string]: { share: number; name: string }[];
		};
		segmentBucketRank: { _id: { segmentName: string; bucketName: string }; maxRank: number };
	} = history?.location?.state?.mapValues;

	return { data: getFormDefaults(segmentList, mapValues), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
